import { PayloadEpic } from '@/store/epics/epic-types';
import { catchError, filter, switchMap } from 'rxjs/operators';
import { actions, asyncActions } from '@/store/slices';
import { concat, of } from 'rxjs';
import axios from 'axios-observable';
import { apiEndpoints } from '@/store/constants';
import { UserModel } from '@/models';
import { CreateUserPayload } from '@/store/slices/staff/users.slice';

export const createUserEpic: PayloadEpic<CreateUserPayload, UserModel> = (action$) => {
    return action$.pipe(
        filter(asyncActions.users.createUser.match),
        switchMap(({ payload }) =>
            concat(
                of(actions.users.setIsSaving(true)),
                createUser(payload).pipe(
                    switchMap(({ data }) => [actions.users.addOne(data), actions.users.setSavingErrors(null)]),
                    catchError((error) => {
                        console.error('createUserEpic', error);

                        return of(actions.users.setSavingErrors(error.response.data));
                    })
                ),
                of(actions.users.setIsSaving(false))
            )
        )
    );
};

const createUser = (payload: CreateUserPayload) => {
    return axios.post<UserModel>(apiEndpoints.users(), payload);
};
